import Link from "next/link";
import ImageComponent from "@core/helpers/server/components/image";
import { slide_link_props } from "@/helpers/slideLabel";

export default function HomeTopSliderServer({ slider_data, storage_prefix_url }) {
    return (
        <Link
            href={slider_data?.images?.[0]?.link?.url || ""}
            className="block w-full"
            {...slide_link_props(slider_data?.images?.[0], "اسلاید 1")}>
            <div className="w-full h-64 lg:h-[400px]">
                {
                    slider_data?.images?.[0]?.slide_type === 2 ?
                        <video
                            className="w-full h-full object-cover"
                            src={`${storage_prefix_url}/${slider_data?.images?.[0]?.media?.url}`}
                            autoPlay
                            loop
                            muted
                            playsInline
                        />
                        :
                        <ImageComponent
                            storage_prefix_url={storage_prefix_url}
                            src={slider_data?.images?.[0]?.media?.url}
                            alt={slider_data?.images?.[0]?.media?.alt || ""}
                            width={1024}
                            height={400}
                            style={{ width: "100%", height: "100%" }}
                            className="object-cover"
                            // اسلاید اول تصویر LCP صفحه‌ی خانه است: preload + fetchpriority=high. از بهینه‌ساز Next رد می‌شود
                            // (WebP/AVIF به اندازه‌ی صفحه) و props با نسخه‌ی کلاینت یکی است تا بعد از hydrate همان فایل استفاده شود
                            isLCP
                            // core برای تصویر سروری quality=100 می‌گذارد؛ برای تصویر LCP فایل را سنگین می‌کرد.
                            // باید با index.client.jsx یکی بماند وگرنه بعد از hydrate فایل دوم دانلود می‌شود.
                            quality={75}
                        />
                }
            </div>
        </Link>
    );

}

